import { SELECT_ORDER, RECEIVE_ORDER, UPDATE_ORDER, LOADING_ORDER, RECEIVE_ORDERS } from '../actions';

function order(
  state = {
    isFetching: false,
  },
  action
) {
  switch (action.type) {
    case LOADING_ORDER:
      return Object.assign({}, state, {
        isFetching: true,
        idOrder: action.idOrder,
      });
    case SELECT_ORDER:
      return Object.assign({}, state, {
        isFetching: false,
        idOrderSelected: action.idOrder,
      });
    case RECEIVE_ORDERS: {
      if (!state.data) {
        return state;
      }
      const index = action.orders.findIndex(item => item.id == state.data.id);
      if (index < 0) {
        return state;
      }
      return {
        ...state,
        data: {
          ...state.data,
          ...action.orders[index],
        },
      };
    }
    case RECEIVE_ORDER:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.order,
      });
    case UPDATE_ORDER:
      return Object.assign({}, state, {
        data: {
          ...state.data,
          ...action.order,
          orderStatusLog: [
            ...(state.data && state.data.orderStatusLog || []),
            {
              id: new Date().getTime(),
              idOrder: action.order.id,
              idOrderSource: 2,
              idOrderStatus: action.order.status,
              timestampCreation: new Date().getTime(),
            },
          ],
        },
      });
    default:
      return state;
  }
}

export default order;



// WEBPACK FOOTER //
// ./src/reducers/order.js